export default __webpack_public_path__ + "static/media/background_cover.f9fa23ad.jpeg";